// extracted by mini-css-extract-plugin
export default {"card":"NewsletterCard_card__6Qk9z","actions":"NewsletterCard_actions__AGOjV","primary":"NewsletterCard_primary__7SCjy","secondary":"NewsletterCard_secondary__ledDZ"};